export default "__VITE_ASSET__b617d799__"